import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";

import { addDays, startOfWeek, format, subWeeks, addWeeks } from "date-fns";
import Api from "../Api";
import axios from "axios";
import { BASE_API_URL } from "../const";
import { ru } from "date-fns/locale";

const GetEPG = () => {
  const [responseListChannels, setResponseListChannels] = useState();
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [responseAPI, setResponseAPI] = useState();
  const [editedData, setEditedData] = useState();
  const [selectedDay, setSelectedDay] = useState(null);
  const [loadingData, setLoadingData] = useState(false);

  const daysOfWeek = Array.from({ length: 7 }, (_, i) =>
    format(
      addDays(startOfWeek(currentWeek, { weekStartsOn: 1 }), i),
      "yyyy-MM-dd"
    )
  );
  const dayLabels = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

  useEffect(() => {
    getDataListChannels();
  }, []);

  useEffect(() => {
    if (responseAPI) {
      setEditedData(responseAPI.map((item) => ({ ...item }))); // Создаем копию данных
    }
  }, [responseAPI]);

  async function getDataListChannels() {
    try {
      const response = await axios.get(`${BASE_API_URL}/api/channel/list`);
      setResponseListChannels(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }
  const handlePreviousWeek = () => {
    setCurrentWeek((prev) => subWeeks(prev, 1));
  };
  const getNextMonday = () => {
    // Если selectedDay не определён, используем текущую дату
    const referenceDate = selectedDay || new Date();
    const nextMonday = startOfWeek(addWeeks(referenceDate, 1), {
      weekStartsOn: 1,
    }); // Получаем дату следующего понедельника
    return format(nextMonday, "yyyy-MM-dd"); // Форматируем дату
  };
  const handleNextWeek = () => {
    setCurrentWeek((prev) => addWeeks(prev, 1));
    if (!selectedChannel) return;
    const nextMondayDate = getNextMonday();
    setSelectedDay(nextMondayDate);
    fetchProgramData(selectedChannel, nextMondayDate);
  };

  const handleRowClick = (element) => {
    setSelectedChannel(element.id);

    if (element.end_program_date && element.end_program_date.includes(" ")) {
      const dateOnly = element.end_program_date.split(" ")[0];
      const endDate = new Date(dateOnly);

      // Считаем начало недели, в которую попадает end_program_date
      const startOfTargetWeek = startOfWeek(endDate, { weekStartsOn: 1 });

      // Обновляем текущую неделю, чтобы нужная дата попала в диапазон дней
      setCurrentWeek(startOfTargetWeek);

      // Устанавливаем выбранный день и загружаем данные
      setSelectedDay(dateOnly);
      fetchProgramData(element.id, dateOnly);
    }
  };
  // Функция для обработки нажатия на кнопку с днем
  const handleDateButtonClick = (date) => {
    if (!selectedChannel) return; // Проверка на наличие выбранного канала
    setSelectedDay(date);
    fetchProgramData(selectedChannel, date);
  };

  // Функция для GET-запроса с использованием выбранного канала и даты
  async function fetchProgramData(channelId, date) {
    setLoadingData(true); // Показываем спиннер
    try {
      const response = await axios.post(`${BASE_API_URL}/api/met`, {
        channel_id: channelId,
        date: date,
      });
      setResponseAPI(response.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingData(false); // Скрываем спиннер
    }
  }

  return (
    <>
      {responseListChannels && responseListChannels.length > 0 && (
        <Box>
          {/* Заголовок */}
          <Box
            sx={{
              backgroundColor: "#E0F7FA",
              padding: 2,
              borderRadius: "8px 8px 0 0",
            }}
          >
            <Typography variant="h5" align="center" color="primary">
              EPG
            </Typography>
          </Box>

          <Box sx={{ display: "flex", height: "100%" }}>
            {/* Левая часть с каналами */}
            <Box sx={{ width: "25%", padding: 2 }}>
              <TableContainer component={Paper}>
                <Table
                  sx={{
                    "& .MuiTableCell-root": {
                      padding: "6px 8px", // Уменьшаем отступы
                    },
                  }}
                >
                  <TableBody sx={{ border: "1px solid #ddd" }}>
                    {responseListChannels
                      .filter((element) => element.visible_menu === 1)
                      .map((element, index) => (
                        <TableRow
                          key={index}
                          onClick={() => handleRowClick(element)}
                          sx={{
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#f0f0f0" },
                          }}
                        >
                          <TableCell
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            {element.name}
                            {selectedChannel === element.id && (
                              <CheckIcon
                                sx={{
                                  color: "green",
                                  fontSize: 20, // Large size for the checkmark
                                  marginLeft: 1,
                                }}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Правая часть */}
            <Box sx={{ width: "75%", padding: 2 }}>
              {/* Кнопки с датами */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "center",
                  marginBottom: 2,
                }}
              >
                {daysOfWeek.map((day, index) => (
                  <Button
                    key={index}
                    variant="contained"
                    color={selectedDay === day ? "secondary" : "primary"}
                    onClick={() => handleDateButtonClick(day)}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      minWidth: 80,
                    }}
                  >
                    <Typography variant="body2">{day}</Typography>
                    <Typography variant="caption">
                      {dayLabels[index]}
                    </Typography>
                  </Button>
                ))}
              </Box>

              {/* Кнопки для переключения недель */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  marginBottom: 2,
                }}
              >
                <Button variant="outlined" onClick={handlePreviousWeek}>
                  Предыдущая неделя
                </Button>
                <Button variant="outlined" onClick={handleNextWeek}>
                  Следующая неделя
                </Button>
              </Box>

              {/* <Box display="flex" justifyContent="center" alignItems="center">
                {loadingData && (
                  <CircularProgress
                    color="primary" // или secondary / inherit
                    size={60} // размер в px
                    thickness={5} // толщина линии
                  />
                )}
              </Box> */}

              {/* Таблица с расписанием */}
              {loadingData ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  minHeight="200px"
                >
                  <CircularProgress size={60} thickness={5} />
                </Box>
              ) : (
                editedData && (
                  <TableContainer
                    component={Paper}
                    sx={{ width: "60%", margin: "0 auto", marginTop: 4 }}
                  >
                    <Table
                      sx={{
                        "& td, & th": { padding: "8px" },
                      }}
                    >
                      <TableBody>
                        {editedData.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ width: "150px" }}>
                              {item.dt_start}
                            </TableCell>
                            <TableCell
                              sx={{
                                maxWidth: 250,
                                minWidth: 250,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <a
                                href={item.met_uid}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {item.subtitle}
                              </a>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default GetEPG;
